// @flow
import { combineReducers } from "redux";

import * as auction from "./controllers/auction";
import * as auctions from "./auctions";
import * as calendar from "./calendar";
import * as categories from "./categories";
import * as contentMenu from "./contentMenu";
import * as contentPage from "./contentPage";
import * as featured from "./featured";
import * as locale from "./controllers/locale";
import * as locales from "./locales";
import * as page from "./page";
import * as translations from "./translations";

export default combineReducers({
  ...auction,
  ...auctions,
  ...calendar,
  ...categories,
  ...contentMenu,
  ...contentPage,
  ...featured,
  ...locale,
  ...locales,
  ...page,
  ...translations
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js